import { render, staticRenderFns } from "./outStorage.vue?vue&type=template&id=980dd954&scoped=true"
import script from "./outStorage.vue?vue&type=script&lang=js"
export * from "./outStorage.vue?vue&type=script&lang=js"
import style0 from "./outStorage.vue?vue&type=style&index=0&id=980dd954&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980dd954",
  null
  
)

export default component.exports